export const AppIcons = {
    ALARM: "Alarm",
    ANNOUNCEMENT: "Announcement",
    ARROW_SOUTH: "ArrowSouth",
    ARROW_NORTH: "ArrowNorth",
    ARROW_WEST: "ArrowWest",
    ARROW_EAST: "ArrowEast",
    ARROW_UP: "ArrowUp",
    APPLICATION_FORM: "ApplicationForm",
    ARCHIVE2: "Archive2",
    BOOK_OPEN: "BookOpen",
    BOOKMARK: "Bookmark",
    BANK_WITH_PLUS: "BankWithPlus",
    BLUE_CALENDAR: "BlueCalendar",
    BILLABLE: "Billable",
    BAN: "Void",
    BLUE_CIRCLE_WITH_DOLLAR_SIGN: "BlueCircleWithDollarSign",
    BADGE2: "Badge2",
    BUILDING: "Building",
    BOX_WITH_STAR: "BoxWithStar",
    BLUE_CUBE: "BlueCube",
    BOX: "Box",
    BULLETS: "Bullets",
    BLUE_SILHOUETTE: "BlueSilhouette",
    BARCODE: "Barcode",
    BRIEFCASE2: "Briefcase2",
    BOX_WITH_LABEL: "BoxWithLabel",
    BALLOON: "Balloon",
    CLOCK: "Clock",
    CALENDAR: "Calendar",
    CALENDAR_TASK: "CalendarTask",
    CATEGORY: "Category",
    COPY: "Copy",
    CROP: "Crop",
    CALCULATOR: "Calculator",
    CABINET: "Cabinet",
    CROSS: "Cross",
    CHECK: "Check",
    CARD_WITH_ADDRESS: "CardWithAddress",
    CIRCLE_WITH_CHECK_MARK: "CircleWithCheckMark",
    CIRCLE_WITH_X: "CircleWithX",
    CREDIT_CARD_GREEN: "CreditCardGreen",
    CUBE_BLUE: "CubeBlue",
    CREDIT_CARD_RED: "CreditCardRed",
    COLOR_SWATCH: "color_swatch",
    COMMENT: "Comment",
    COMPUTER: "Computer",
    COMPUTER_WITH_PLUS: "ComputerWithPlus",
    CONTRAST: "Contrast",
    DOCUMENT: "Document",
    DOCUMENT_WITH_TEXT: "DocumentWithText",
    DOCUMENT_WORD: "DocumentWord",
    DISABLE: "Disable",
    DOLLAR: "Dollar",
    DRAWER: "Drawer",
    DOCUMENT_EXCEL: "DocumentExcel",
    DOWNLOAD: "Download",
    DOWN: "Down",
    ENABLED: "Enabled",
    EXCLAMATION_ALERT: "exclamation-alert",
    EDIT: "edit",
    EYE: "Eye",
    FOLDER_HORIZONTAL_CLOSED: "FolderHorizontalClosed",
    FOLDER: "Folder",
    FAX: "FAX",
    FLAG: "Flag",
    GREEN_CALENDAR: "GreenCalendar",
    GEAR: "Gear",
    GLOBE: "Globe",
    GREEN_CLOCK: "GreenClock",
    GREEN_CUBE: "GreenCube",
    HOME: "Home",
    HAND_WITH_APPLICATION: "HandWithApplication",
    HORIZONTAL_DOCUMENT_WITH_TEXT: "HorizontalDocumentWithText",
    IMAGE_SUNSET: "ImageSunset",
    IMAGE: "Image",
    INFO: "Info",
    ID: "ID",
    JOURNAL_VIEW: 'journal-view',
    LIGHTNING: "Lightning",
    LIGHTBULB: "lightbulb",
    LAYOUT: "Layout",
    LIST: "List",
    LAYOUT_SPLIT_VERTICAL: "LayoutSplitVertical",
    LICENSE: "License",
    LOCK: "Lock",
    LOCK2: "Lock2",
    LINK: "Link",
    MONEY: "Money",
    MAIL: "Mail",
    MAILS: "Mails",
    MALLET: "Mallet",
    MOBILE_PHONE: "MobilePhone",
    MOVE: "Move",
    MONEY_WITH_MINUS: "MoneyWithMinus",
    MINUS: "Minus",
    NOTEBOOK: "Notebook",
    NUMBER: "Number",
    NAME_TAG: "Nametag",
    ORIENTATION: "Orientation",
    ORDER: "Order",
    PLUS: "Plus",
    PREVIEW: "Preview",
    PASSWORD: "Password",
    PRINTER: "Printer",
    PEN: "Pen",
    PIE_GRAPH: "PieGraph",
    PENCIL: "Pencil",
    PICTURE: "Picture",
    PAGE_STACK: "PageStack",
    PERCENTAGE: "Percentage",
    PROPERTY: "Property",
    PERCENTAGE_BLACK: "PercentageBlack",
    PROGRESS: "Progress",
    PAPER_CLIP: "PaperClip",
    QUESTION: "Question",
    REPLY: "Reply",
    REPEAT: "Repeat",
    REPORT: "Report",
    REFRESH: "Refresh",
    RED_CLOCK: "RedClock",
    RED_CREDIT_CARD: "RedCreditCard",
    RECEIPT: "Receipt",
    REFRESH2: "Refresh2",
    RESIZE_HORIZONTAL: "ResizeHorizontal",
    RECEIPT_WITH_MINUS: "ReceiptWithMinus",
    TRASH: "Trash",
    TAG: "Tag",
    T: "T",
    TICK: "Tick",
    TICKET: "Ticket",
    TARGET: "Target",
    TEMPLATE: "Template",
    TAXES: "Taxes",
    SHRED: "Shred",
    SITEMAP: "Sitemap",
    SAFE: "Safe",
    STAMP: "Stamp",
    SAVE_TICK: "SaveTick",
    SILVER_BOX: "SilverBox",
    SECTION_HOME: "SectionHome",
    SAILING_SHIP: "SailingShip",
    SIGNATURE: "Signature",
    SCRIPT: "Script",
    SECTION_CLOCK: "SectionClock",
    SECTION_FILE: "SectionFile",
    USER_SILHOUETTE: "UserSilhouette",
    USERS_WITH_PLUS: "UsersWithPlus",
    USERS: "Users",
    UNLINK: "Unlink",
    WALLET: "Wallet",
    WRENCH: "Wrench",
    WHITE_REFRESH: "WhiteRefresh",
    YELLOW_SILHOUETTE: "YellowSilhouette",
    YELLOW_CALENDAR: "YellowCalendar",
}